import { useEffect } from 'react';
import { initializeControls } from '@atlassian/browser-storage-controls';

export const BrowserStorageControlsInit = () => {
	useEffect(() => {
		initializeControls({ product: 'Jira' });
	}, []);

	return null;
};
